<template>
  <l-layout :layout="[ 'lg12']" bottom-space >
    <v-card>
      <v-card-title style="height: 64px">
        <span class="title pl-2">{{groupType.name}}</span>
        <span class="grey--text px-2" v-if="editing">正在编辑</span>
        <v-spacer></v-spacer>
        <v-btn @click="goReadonly()" color="primary" flat v-if="editing">返回</v-btn>
      </v-card-title>
      <v-card-text>
        <v-container class="py-0" fluid grid-list-md>
          <v-form ref="groupType">
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="类型名称"
                  prepend-icon="$vuetify.icons.group"
                  v-model="groupType.name"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  :rows="1"
                  auto-grow
                  label="类型描述"
                  prepend-icon="$vuetify.icons.description"
                  v-model="groupType.description"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
    </v-card>
    <v-layout class="mt-2 text-xs-right">
      <v-flex v-if="newItem">
        <v-btn :loading="submitLoading" @click="setGroupType(groupType)" class="mx-0" color="primary">提交</v-btn>
      </v-flex>
      <v-flex v-if="editing" xs12>
        <v-btn
          :loading="submitLoading"
          @click="setGroupType(groupType)"
          class="mx-0"
          color="primary"
        >提交更改
        </v-btn>
      </v-flex>
    </v-layout>

  </l-layout>
</template>

<script>
import {GroupType} from '../../../../object'

export default {
  name: 'typeForm',
  props: {
    groupType: {
      type: Object,
      default: () => new GroupType()
    }
  },
  data: () => ({
    submitLoading: false,
  }),
  computed: {
    newItem () {
      return this.$route.name === 'NewGroupType'
    },
    editing () {
      return this.$route.name === 'EditGroupType'
    },
  },
  methods: {
    async setGroupType (groupType) {
      this.submitLoading = true
      try {
        await this.$store.dispatch('userAdmin/setGroupType', groupType)
        this.$L.alert('success', '提交成功')
        await this.$L.tab.close(this.$L.tab.current, false)
        this.$router.push({
          name: 'GroupTypeList',
          params: {refresh: true}
        })
      }
      catch (e) {
        this.$L.alert('error', e.message)
      }
      finally {
        this.submitLoading = false
      }
    },
    goReadonly () {
      this.$store.dispatch('L/routerInTab').then(() => {
        this.$router.replace({
          name: 'GroupTypeDetails',
          params: {name: this.groupType.name},
          query: {id: this.groupType.id}
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
